import { FocusEvent, FocusEventHandler, useState } from 'react'
import Select from 'react-select'
import { Box } from 'theme-ui'
import theme from 'theme'
import { TeachingOrgProps } from 'types'
import { ChevronDownIcon } from 'components/Icon'
import { customSelectStyles } from 'components/Form/styles'
import { noop } from 'utils'

export type TeachingOrgSelectProps = {
  id?: string
  name: string
  options: TeachingOrgProps[]
  value?: TeachingOrgProps | undefined
  placeholder?: string | undefined
  disabled?: boolean
  hasErrors?: boolean
  tabIndex?: number
  onChange?: (org: TeachingOrgProps) => void
  onBlur?: FocusEventHandler
  'data-cy'?: string
}

const DropdownIndicator = () => (
  <Box sx={{ width: 20, height: 20 }}>
    <ChevronDownIcon />
  </Box>
)

export function TeachingOrgSelect({
  id,
  name,
  options,
  value,
  placeholder = 'Select',
  disabled = false,
  hasErrors = false,
  onChange = noop,
  onBlur = noop,
  tabIndex,
  ...props
}: TeachingOrgSelectProps) {
  const [focused, setFocused] = useState(false)
  const handleBlur = (evt: FocusEvent<HTMLElement>) => {
    const blurEvt = evt as FocusEvent<HTMLInputElement>
    blurEvt.target.name = name
    onBlur(blurEvt)
    setFocused(false)
  }
  return (
    <Box
      id={id}
      data-cy={props['data-cy']}
      sx={{
        p: '10px',
        boxSizing: 'border-box',
        width: '100%',
        bg: 'oldlace',
        borderRadius: 8,
        boxShadow: hasErrors
          ? '0 0 0 2px #f87e0e'
          : focused
          ? '0 0 0 2px #ffc436'
          : 'none',
        opacity: disabled ? 0.6 : 1,
      }}>
      <Select
        aria-label={`select-${name}`}
        name={name}
        placeholder={placeholder}
        options={options}
        getOptionLabel={(option) => `${option.name}`}
        getOptionValue={(option) => `${option.id}`}
        value={value}
        components={{ DropdownIndicator }}
        styles={customSelectStyles}
        theme={(t) => ({
          ...t,
          colors: {
            ...t.colors,
            primary: theme.colors.primary,
            primary50: theme.colors.darkyellow,
            primary25: theme.colors.oldlace,
          },
        })}
        tabIndex={`${tabIndex}`}
        isDisabled={disabled}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        isSearchable
      />
    </Box>
  )
}
